import { createAction } from "@redux/actions/actionCreators";

const [useDeleteProductOption, deleteProductOption] = createAction<{
  productUuid: string;
  index: number;
}>("product/deleteOption");

export default useDeleteProductOption;
export { deleteProductOption };
